export const parse = function(queryString) {
  var query = {};
  var pairs = (queryString[0] === '?'
    ? queryString.substr(1)
    : queryString
  ).split('&');
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = convertIfBoolean(
      decodeURIComponent(pair[1] || '')
    );
  }
  return query;
};

export const stringify = function(params) {
  return (
    '?' +
    Object.keys(params)
      .map(key => key + '=' + params[key])
      .join('&')
  );
};

function convertIfBoolean(str) {
  if (str === 'true') return true;
  if (str === 'false') return false;
  return str;
}
